







































































































import Vue from 'vue';
import {
  Component, Inject, Watch,
} from 'vue-property-decorator';
import {
  Alert,
  NoticeClass,
  Dialog,
} from '@kasasa/fbase-components/lib';
import { KCardHeader, KCardHeaderBtn } from '@kasasa/fbase-components';
import { MacroResource, Macro } from '@/api/macro';
import { AnswerMap } from '@/api/AnswerMap';
import CodeEditor from '@/components/CodeEditor.vue';
import MacroPreviewOptions from '@/components/MacroPreviewOptions.vue';
import MacroPreview from '@/components/MacroPreview.vue';

@Component({
  components: {
    KCardHeader, KCardHeaderBtn, CodeEditor, MacroPreviewOptions, MacroPreview,
  },
})
export default class MacroView extends Vue {
  title:string = '';

  macro: Macro | null = null;

  workingMacro: Macro | null = null;

  validForm: boolean = true;

  saving: boolean = false;

  previewAnswers: AnswerMap = {};

  previewFiId: string = '99999';

  headerItems: any = [
    {
      text: 'RegGen',
      disabled: false,
      link: false,
    },
    {
      text: 'Macros',
      disabled: false,
      link: true,
      href: '/macros',
    },
    {
      text: '',
      disabled: true,
    },
  ];

  @Inject('MacroResource')
  macroResource!: MacroResource;

  requiredRule = (value: string | null): boolean | string => {
    if (!value || value.length === 0) {
      return 'Value is required';
    }
    return true;
  }

  macroNameRule = (value: string | null): boolean | string => {
    if (value && !/^[a-zA-Z0-9'-_]*$/.test(value)) {
      return 'Macro name may only contain alphanumeric characters, dashes and underscores.';
    }
    return true;
  }

  mounted() {
    this.onNewRoute();
  }

  @Watch('$route', { deep: true })
  onNewRoute() {
    this.macro = null;
    this.workingMacro = null;
    if (this.$route.params.macroId) {
      this.loadMacro(this.$route.params.macroId);
    } else {
      this.createNewMacro();
    }
  }

  createNewMacro() {
    this.macro = {
      name: '',
      description: '',
      rule: '',
      text: '',
      isRoot: false,
      references: null,
      updatedTime: null,
    };

    this.workingMacro = Object.assign({}, this.macro);

    this.title = 'New Macro';
    this.headerItems[2].text = 'New Macro';
  }

  loadMacro(macroId: string) {
    this.macroResource.get(macroId, true).then((macro:Macro | null) => {
      if (!macro) {
        this.showErrorMessage(`Macro ${macroId} was not found.`);
      } else {
        this.macro = macro;
        this.headerItems[2].text = macro.name;
        this.title = macro.name;
        this.workingMacro = Object.assign({}, macro);
      }
    }).catch((error:any) => {
      this.showErrorMessage(error);
    });
  }

  goBack() {
    this.$router.push({ name: 'macros' });
  }

  onSave() {
    this.saving = true;
    if (this.macro!.name !== this.workingMacro!.name) {
      this.checkForExistingMacroAndSave();
    } else {
      this.save();
    }
  }

  onNew() {
    if (this.workingMacroIsDirty()) {
      const dialog = new Dialog('Confirm New Macro', 'You have unsaved changes. Are you sure you want to create a new macro?');
	      dialog.setAcceptLabel('OK')
	        .setDeclineLabel('Cancel');
	      this.$store.dispatch('notices/add', dialog).then((ok) => {
	        if (ok === 'accept') {
          this.createNewMacro();
        }
      });
    } else {
      this.createNewMacro();
    }
  }

  onReset() {
    if (this.workingMacroIsDirty()) {
      const dialog = new Dialog('Confirm Reset', 'You have unsaved changes. Are you sure you want to undo them?');
	      dialog.setAcceptLabel('OK')
	        .setDeclineLabel('Cancel');
	      this.$store.dispatch('notices/add', dialog).then((ok) => {
	        if (ok === 'accept') {
          Object.assign(this.workingMacro, this.macro);
        }
      });
    }
  }


  workingMacroIsDirty() : boolean {
    return (this.workingMacro !== null && this.macro !== null) && (this.workingMacro!.name !== this.macro!.name || this.workingMacro!.description !== this.macro!.description
      || this.workingMacro!.rule !== this.macro!.rule || this.workingMacro!.text !== this.macro!.text || this.workingMacro!.isRoot !== this.macro!.isRoot);
  }

  checkForExistingMacroAndSave() {
    this.macroResource.get(this.workingMacro!.name, false).then((macro:Macro | null) => {
      if (macro) {
        const dialog = new Dialog('Confirm Save', `A macro with the name ${this.workingMacro!.name} already exists.  Are you sure you want to overwrite it?`);
	      dialog.setAcceptLabel('OK')
	        .setDeclineLabel('Cancel');
	      this.$store.dispatch('notices/add', dialog).then((ok) => {
	        if (ok === 'accept') {
            this.save();
          } else {
            this.saving = false;
          }
        });
      } else {
        this.save();
      }
    });
  }

  save() {
    this.macroResource.save(this.workingMacro!).then((saved: Macro) => {
      this.showSuccessMessage('Macro saved.');
      Object.assign(this.macro, saved);
    }).catch((error:any) => {
      this.showErrorMessage(error);
    }).finally(() => {
      this.saving = false;
    });
  }

  onNewPreviewAnswers(answers:AnswerMap) {
    this.previewAnswers = answers;
  }

  onNewPreviewFiId(fiId: string) {
    this.previewFiId = fiId;
  }

  showErrorMessage(error: any) {
    console.error(error);
    const al = new Alert(error, NoticeClass.ERROR);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }

  showSuccessMessage(message: string) {
    const al = new Alert(message, NoticeClass.SUCCESS);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }
}
